import { generateDeviceKeyPair, exportPublicKeyRaw } from './crypto'
import { saveDevice } from './db'
import { enrollDevice } from './api'

export async function performEnrollment(
  enrollmentCode: string,
  deviceLabel?: string,
): Promise<void> {
  const keyPair = await generateDeviceKeyPair()
  const publicKeyRaw = await exportPublicKeyRaw(keyPair.publicKey)

  const { deviceId, tenantSlug } = await enrollDevice({
    enrollmentCode,
    devicePublicKeyRaw: publicKeyRaw,
    deviceLabel,
  })

  await saveDevice({
    id: 'self',
    deviceId,
    tenantSlug,
    privateKey: keyPair.privateKey,
    publicKeyRaw,
    monotonicCounter: 0,
  })
}
